module.exports = __webpack_public_path__ + "img/Chandanni.c53ccf05.png";